import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { blsUser } from '../../../models/users-models/blsUser';

export const usersAdapter: EntityAdapter<blsUser> = createEntityAdapter<blsUser>();
